






import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Patient } from "../../../../../../domain/patient";
import { ExternalImageItem } from "../../../../../../domain/externalImage";
import { DomainRegistry } from "../../../../../../domain";
import { ModelEditableMixin } from "../../../../../system/mixins";

@Component({
  components: {
  }
})
export default class ExternalImageFinder extends Mixins(ModelEditableMixin) {
  editingSource: ExternalImageItem[];

  @Prop()
  patient: Patient;

  @Prop()
  isFinding: boolean;

  @Emit("update:isFinding")
  updateIsFinding(value: boolean) {}

  get isFindingAccessor(): boolean {
    return this.isFinding;
  }

  set isFindingAccessor(value: boolean) {
    this.updateIsFinding(value);
  }

  get externalImageName(): string {
    return this.$configuration.behavior.collaboration.externalImage.imageName;
  }

  mounted() {
    this.loadImages();
  }

  loadImages() {
    if (this.isFindingAccessor) {
      this.$logger.warn("検索中です。");
      return;
    }
    this.isFindingAccessor = true;
    this.editingSource = [];
    const repository = DomainRegistry.externalImage.getExternalImageRepository();
    repository.getExternalImageItems(this.patient.id)
      .then(e => {
        this.editingSource = e;
        this.isFindingAccessor = false;
      })
      .catch(e => {
        this.isFindingAccessor = false;
        this.$error(
          this.externalImageName + "検索失敗",
          this.externalImageName + "検索失敗しました。",
          e,
        );
      });
  }
}
